import { useCallback } from "react";
import { generatePath, useNavigate } from "react-router-dom";

import { SearchParamKeys } from "../../../shared/hooks";
import { AbsoluteRoute } from "../absoluteRoutes";

export const useWebLensRoutes = (): {
    goToWebLensSubmit: (organizationId: string, folderId: string) => void;
    goToWebLensPushToDevice: (organizationId: string) => void;
} => {
    const navigate = useNavigate();

    // The org lives in the path (container-feature convention); only the Lens Space rides the
    // query string, so the submit page can re-resolve it on reload and the chooser can open
    // prefilled from the submit page's "change" link. Org switching is not a concern here: the
    // app-level org menu handles it via FEATURE_ORG_ROUTE_MAP.
    const goToWebLensSubmit = useCallback(
        (organizationId: string, folderId: string) => {
            const search = new URLSearchParams({ [SearchParamKeys.LensFolder]: folderId });
            navigate({
                pathname: generatePath(AbsoluteRoute.WEB_LENSES_SUBMIT, { orgId: organizationId }),
                search: search.toString(),
            });
        },
        [navigate],
    );

    // No folder in the picture: the preview is ephemeral and never lands in a Lens Space, so the
    // push page needs only the org the path convention requires.
    const goToWebLensPushToDevice = useCallback(
        (organizationId: string) => {
            navigate(generatePath(AbsoluteRoute.WEB_LENSES_PUSH_TO_DEVICE, { orgId: organizationId }));
        },
        [navigate],
    );

    return {
        goToWebLensSubmit,
        goToWebLensPushToDevice,
    };
};
